export enum Language {
  EN = 'en',
  ZH = 'zh',
}

// 語系文字對應表
export const languageLabelMap = new Map<Language, string>([
  [Language.EN, 'English'],
  [Language.ZH, '简体中文'],
])
